
export const FETCH_ALL_REGION_ATTRIBUTES_REQUEST = "FETCH_ALL_REGION_ATTRIBUTES_REQUEST";
export const FETCH_ALL_REGION_ATTRIBUTES_SUCCESS = "FETCH_ALL_REGION_ATTRIBUTES_SUCCESS";
export const FETCH_ALL_REGION_ATTRIBUTES_ERROR = "FETCH_ALL_REGION_ATTRIBUTES_ERROR";
export const UPDATE_ALL_REGION_ATTRIBUTES = "UPDATE_ALL_REGION_ATTRIBUTES";